export const GROUP_PERMISSIONS_LIST = "GROUP_PERMISSIONS_LIST"
export const GROUP_PERMISSIONS_LIST_SUCCESS = "GROUP_PERMISSIONS_LIST_SUCCESS"
export const GROUP_PERMISSIONS_LIST_ERROR = "GROUP_PERMISSIONS_LIST_ERROR"

export const GROUP_PERMISSIONS_NEW = "GROUP_PERMISSIONS_NEW"
export const GROUP_PERMISSIONS_NEW_SUCCESS = "GROUP_PERMISSIONS_NEW_SUCCESS"
export const GROUP_PERMISSIONS_NEW_ERROR = "GROUP_PERMISSIONS_NEW_ERROR"

export const GROUP_PERMISSIONS_EDIT = "GROUP_PERMISSIONS_EDIT"

export const GROUP_PERMISSIONS_DELETE = "GROUP_PERMISSIONS_DELETE"
export const GROUP_PERMISSIONS_DELETE_SUCCESS = "GROUP_PERMISSIONS_DELETE_SUCCESS"
export const GROUP_PERMISSIONS_DELETE_ERROR = "GROUP_PERMISSIONS_DELETE_ERROR"

export const GROUP_PERMISSIONS_TYPES_LIST = "GROUP_PERMISSIONS_TYPES_LIST"
export const GROUP_PERMISSIONS_TYPES_LIST_SUCCESS = "GROUP_PERMISSIONS_TYPES_LIST_SUCCESS"
export const GROUP_PERMISSIONS_TYPES_LIST_ERROR = "GROUP_PERMISSIONS_TYPES_LIST_ERROR"